import _ from 'lodash'
import  { ActionType, Enum } from "./../resources/constants"

const { SET_USER, SET_ACCESS_TOKEN, SET_SOURCES, SET_DEFAULT_SOURCE, SET_TENDERS_DASHBOARD, SET_TENDERS, SET_TENDERS_PAGINATION, SET_FILTER, SET_PRIMARY_FILTER, SET_POSTED_DATE } = ActionType
const { TopFilter } = Enum;

export default function GlobalReducer(state: any, action: { type: string, payload?: any }) {
    switch (action.type) {
        case SET_SOURCES:
            return setSources(state,action);
        case SET_DEFAULT_SOURCE:
            return setDefaultSource(state,action);
        case SET_USER:
            return setUser(state,action);
        case SET_TENDERS_DASHBOARD:
            return setTendersDashboard(state,action);
        case SET_TENDERS:
            return setTenders(state,action);
        case SET_TENDERS_PAGINATION:
            return setTendersPagination(state,action);
        case SET_FILTER:
            return setFilter(state,action);
        case SET_PRIMARY_FILTER:
            return setPrimaryFilter(state,action);
        case SET_ACCESS_TOKEN:
            return setAccessToken(state,action);
        case SET_POSTED_DATE:
            return setPostedDate(state,action);
        default:
            return state;
    }
}

const setSources = (state: any, action: { type: string, payload?: any } ) => {
    const { sources } = action.payload;

    return {
        ...state,
        sources
    }
}

const setDefaultSource = (state: any, action: { type: string, payload?: any } ) => {
    const { defaultSource } = action.payload;

    return {
        ...state,
        defaultSource
    }
}

const setUser = (state: any, action: { type: string, payload?: any } ) => {
    const { user } = action.payload;

    return {
        ...state,
        user
    }
}

const setTenders = (state: any, action: { type: string, payload?: any } ) => {
    const { tenders } = action.payload;

    return {
        ...state,
        tenders
    }
}

const setTendersPagination = (state: any, action: { type: string, payload?: any } ) => {
    const { tendersPagination } = action.payload;

    return {
        ...state,
        tendersPagination
    }
}

const setFilter = (state: any, action: { type: string, payload?: any } ) => {
    const { filter } = action.payload;

    return {
        ...state,
        filter
    }
}

const setPrimaryFilter = (state: any, action: { type: string, payload?: any } ) => {
    const { primaryFilter } = action.payload;
    const { topFilters: topFiltersPrev } = state;
    const topFiltersNext: string[] = [...topFiltersPrev];

    if (primaryFilter?.expired === true) topFiltersNext.push(TopFilter.Basic_Search)
    else if (primaryFilter?.expired === false) _.remove(topFiltersNext, (topFilter) => topFilter === TopFilter.Basic_Search);

    if (primaryFilter?.eligible === true) topFiltersNext.push(TopFilter.Felix_Fusion_Picks)
    else if (primaryFilter?.eligible === false)  _.remove(topFiltersNext, (topFilter) => topFilter === TopFilter.Felix_Fusion_Picks);

    return {
        ...state,
        topFilters: _.uniq(topFiltersNext),
        primaryFilter
    }
}

const setTendersDashboard = (state: any, action: { type: string, payload?: any } ) => {

    const { tendersDashboard: tendersDashboardPrev } = state;
    const { tendersDashboard: tendersDashboardNext } = action.payload;

    const tendersDashboard = { ...tendersDashboardPrev, ...tendersDashboardNext };

    return {
        ...state,
        tendersDashboard
    }
}

const setAccessToken = (state: any, action: { type: string, payload?: any } ) => {
    const { accessToken } = action.payload;

    return {
        ...state,
        accessToken
    }
}

const setPostedDate = (state: any, action: { type: string, payload?: any } ) => {
    const { postedDate } = action.payload;

    return {
        ...state,
        postedDate
    }
}
